import React from 'react'
import SEO from '../../components/SEO'
import FaEnvelopeO from 'react-icons/lib/fa/envelope-o'
import FaPhone from 'react-icons/lib/fa/phone'
import FaHome from 'react-icons/lib/fa/home'

import style from './index.module.css'

function setHtml($html) {
  return { __html: $html }
}

const Contact = ({ data, transition }) => (
  <div>
  <h2 style={{textAlign: 'center'}}>Contact</h2>
  <div style={transition && transition.style} className={style.wrapper}>
    <SEO slug={'Contact'} />
    <div className={style.inner}>
      <p>
        <FaHome /> <span className={style.innersub}>{data.allMarkdownRemark.edges['0'].node.frontmatter.address}</span>
      </p>
      <p>
        <FaPhone /> <span className={style.innersub}>{data.allMarkdownRemark.edges['0'].node.frontmatter.phone}</span>
      </p>
      <FaEnvelopeO />
      <span className={style.innersub}>
        <a href={`mailto:${data.allMarkdownRemark.edges['0'].node.frontmatter.mail}`} style={{ marginLeft: '4px' }}>
          {data.allMarkdownRemark.edges['0'].node.frontmatter.mail}
        </a>
      </span>
      <div dangerouslySetInnerHTML={setHtml(data.allMarkdownRemark.edges['0'].node.html)} />
    </div>
  </div>
  </div>
)

export default Contact

export const query = graphql`
  query contact {
    allMarkdownRemark(filter: { frontmatter: { slug: { eq: "contact" } } }) {
      edges {
        node {
          html
          frontmatter {
            name
            address
            mail
            phone
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/contact/index.js